import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GuestGuard } from './shared/services/authentication/guest-guard';
import { AuthGuard } from './shared/services/authentication/auth-guard.service';
import { BillingReturnComponent } from './shared/pages/billing-return/billing-return.component';

const routes: Routes = [
  {
    path: '',
    canActivate: [GuestGuard],
    loadChildren: () =>
      import('./landing/landing.module').then(m => m.LandingModule)
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./auth/authentication.module').then(m => m.AuthenticationModule)
  },
  {
    path: 'billing/return',
    canActivate: [AuthGuard],
    component: BillingReturnComponent,
  },
  {
    path: 'app',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    loadChildren: () =>
      import('./layout/layout.module').then(m => m.LayoutModule),
  },
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes,
    {
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
      scrollOffset: [0, 80],
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
